export default function () {
  const element = $('.management__item');
  const mobileWidth = 768;

  element.each((key, item) => {
    const handleOpenCard = function () {
      if($(window).width() > mobileWidth) {
          const descriptionHeight = $(item).find('.management__item-description').prop('scrollHeight');
          const imageHeight = $(item).find('.management__item-img').prop('scrollHeight');
          $(item).find('.management__item-img').css("margin-top", -imageHeight);
          $(item).find('.management__item-description ').stop(false, false).css("height", descriptionHeight);
      }
    }
    const handleCloseCard = function () {
        if($(window).width() > mobileWidth) {
            $(item).find('.management__item-img').css("margin-top", "0");
            $(item).find('.management__item-description ').stop(false, false).css("height", "0");
        }
    }
    $(item).mouseenter(handleOpenCard);
    $(item).mouseleave(handleCloseCard);
    $(window).resize(handleCloseCard);
  })

}
